export const TEXTAREA_CHANGED_DATA_ATTRIBUTE_KEY = "changed";
